import script from "./BareMetal.vue?vue&type=script&setup=true&lang=js"
export * from "./BareMetal.vue?vue&type=script&setup=true&lang=js"

import "./BareMetal.vue?vue&type=style&index=0&id=2be2512f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be2512f"]])

export default __exports__